import {useEffect} from "react";
import * as optionService from "../service/optionService";

export function useOptionGrp(setters, shopId) {
  useEffect(() => {
    const optionGrp = async () => {
      if(shopId) {
        const optionGrpData = await optionService.getOptionGrpList(shopId);

        setters.setOptionGrpList?.(optionGrpData);
      }
    }
    optionGrp();
  }, [shopId])
}

export function useOptionGrp2(setters, shopId) {
  useEffect(() => {
    const optionGrp = async () => {
      if(shopId) {
        const optionGrpData = await optionService.getOptionGrpList2(shopId);

        setters.setOptionGrpList?.(optionGrpData);
      }
    }
    optionGrp();
  }, [shopId])
}


export function useOption(setters, optionGrpId) {
  useEffect(() => {
    const option = async () => {
      if(optionGrpId) {
        const optionData = await optionService.getOptionList(optionGrpId);

        optionData.sort(function(a, b) {
          return parseFloat(a.exposSeq) - parseFloat(b.exposSeq)
        })

        setters.setOptionList?.(optionData);
      }
    }
    option();
  }, [optionGrpId])
}